type PerfWindow = Window & {
  __sixpassPerfMarks?: Map<string, number>;
  __sixpassPerfLogged?: Set<string>;
};

const getPerfWindow = (): PerfWindow | null => {
  if (typeof window === 'undefined') return null;
  const perfWindow = window as PerfWindow;
  perfWindow.__sixpassPerfMarks ||= new Map<string, number>();
  perfWindow.__sixpassPerfLogged ||= new Set<string>();
  return perfWindow;
};

export const perfStart = (name: string) => {
  const perfWindow = getPerfWindow();
  if (!perfWindow) return;
  perfWindow.__sixpassPerfMarks!.set(name, performance.now());
};

export const perfEnd = (name: string, label = name) => {
  const perfWindow = getPerfWindow();
  if (!perfWindow) return;
  const start = perfWindow.__sixpassPerfMarks!.get(name);
  if (typeof start !== 'number') return;
  const elapsed = performance.now() - start;
  console.info(`[PERF] ${label}: ${elapsed.toFixed(1)}ms`);
  perfWindow.__sixpassPerfMarks!.delete(name);
};

export const perfLogOnce = (key: string, label: string, startMark = 'app:start') => {
  const perfWindow = getPerfWindow();
  if (!perfWindow) return;
  if (perfWindow.__sixpassPerfLogged!.has(key)) return;
  const start = perfWindow.__sixpassPerfMarks!.get(startMark);
  const elapsed = typeof start === 'number' ? `${(performance.now() - start).toFixed(1)}ms` : 'n/a';
  console.info(`[PERF] ${label}: ${elapsed}`);
  perfWindow.__sixpassPerfLogged!.add(key);
};
